import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { desktop } from '../native/desktop';

/**
 * In the desktop app Google and Apple refuse to sign in inside the app's window, so the
 * sign-in pages offer the person's own browser instead (src/desktop/ConnectPage.jsx).
 */
const DesktopSignIn = () => {
  const { t } = useTranslation();
  const [waiting, setWaiting] = useState(false);
  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={() => { setWaiting(true); desktop.signInWithBrowser(); }}
        className="w-full flex items-center justify-center gap-3 py-3 px-4 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-colors"
        data-testid="desktop-signin-browser"
      >
        <Globe className="w-5 h-5" />
        <span>{t('desktop.login.browser')}</span>
      </button>
      <p className="text-center text-xs text-gray-500" role="status" aria-live="polite">
        {waiting ? t('desktop.login.waiting') : t('desktop.login.browser_hint')}
      </p>
    </div>
  );
};

export default DesktopSignIn;
